module.exports = __webpack_public_path__ + "static/img/hyzx.6fe9cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyzx.png
// module id = Brwd
// module chunks = 4